import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export function FormFieldErrorMessageUI({ id = null, message = null, className = null }) {
  if (!message) return null;
  return (
    <div id={id} role="alert" className={classnames('size-14 text-danger', className)}>
      {message}
    </div>
  );
}

FormFieldErrorMessageUI.propTypes = {
  id: PropTypes.string,
  message: PropTypes.string,
  className: PropTypes.string,
};

export const FormFieldErrorMessage = React.memo(FormFieldErrorMessageUI);
